(ns manage.adset.modal.db
  (:require ["moment/min/moment-with-locales$default" :as moment]
            [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [lemonpi.specs.interface.adset :as adset-spec]
            [manage.adset.business-logic :as business-logic]
            [manage.spec.adset :as spec.adset]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(defn- valid-channel? [v]
  (contains? (set (map name (keys business-logic/channels))) v))

(defn valid-workflow? [v]
  (contains? (set (map name (keys business-logic/workflows))) v))

(defn selected-one? [v]
  (= (count v) 1))

(defn start-date-in-present? [[^js start _]]
  (let [today (.startOf (moment) "day")]
    (.isSameOrAfter start today)))

(defn end-date-within-one-year? [[^js start ^js end]]
  (let [limit (.add (.clone start) 1 "year")]
    (and (.isSameOrAfter end start)
         (.isSameOrBefore end limit))))

(spec/def ::channel
  valid-channel?)

(spec/def ::workflow
  valid-workflow?)

(spec/def :ctv/countries
  (spec/and ::adset-spec/countries selected-one?))

(defn all-values-present? [values]
  (every? some? values))

(spec/def ::planned-dates
  (spec/and sequential?
            #(= (count %) 2)
            all-values-present?
            start-date-in-present?
            end-date-within-one-year?))

(spec/def ::target-impressions number?)

(defmulti value :channel)

(defmethod value :default []
  (spec/keys :req-un [::spec.adset/name
                      ::channel
                      ::workflow
                      ::target-impressions
                      ::planned-dates]
             :opt-un [::adset-spec/countries]))

(defmethod value "ctv" []
  (spec/keys :req-un [::spec.adset/name
                      ::channel
                      ::workflow
                      :ctv/countries
                      ::planned-dates
                      ::target-impressions]))

(spec/def ::value
  (spec/multi-spec value :channel))

(p/defphraser valid-channel?
  [_ problem]
  {:message "Please select a channel"
   :in (:in problem)
   :problem problem})

(p/defphraser valid-workflow?
  [_ problem]
  {:message "Please select a workflow"
   :in (:in problem)
   :problem problem})

(p/defphraser selected-one?
  [_ problem]
  {:message "Please select a country"
   :in (:in problem)
   :problem problem})

(p/defphraser number?
  [_ problem]
  {:message "Please input expected amount of impressions"
   :in (:in problem)
   :problem problem})

(p/defphraser all-values-present?
  [_ problem]
  {:message "Please select a start and end date"
   :in (:in problem)
   :problem problem})

(p/defphraser start-date-in-present?
  [_ problem]
  {:message "Please select a start date that is not in the past."
   :in (:in problem)
   :problem problem})

(p/defphraser end-date-within-one-year?
  [_ problem]
  {:message "Please select an end date within 1 year after the start date."
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.adset-create ::value)))

(def initial-value
  {:name ""
   :channel ""
   :workflow ""
   :countries []
   :planned-dates [nil nil]
   :target-impressions ""})

(def use-error-message (partial form/use-error-message :form.adset-create))

(def use-bind-control (partial form/use-bind-control :form.adset-create))

(form/register-form {:namespace :form.adset-create
                     :initial-value initial-value
                     :validate-form validate-form})

(rf/reg-sub
  :adset-create/country-options
  :<- [:form.adset-create/value [:channel]]
  (fn [selected-channel]
    (let [channel (keyword selected-channel)
          country-codes (get-in business-logic/channels [channel :countries])]
      (->> (select-keys adset-spec/country-code-to-country-name country-codes)
           (mapv (fn [[k v]]
                   {:value k
                    :label (->> (str/split v #"\s+")
                                (map str/capitalize)
                                (str/join " "))}))
           (sort-by :label)))))
